import React from 'react';
import _ from 'lodash';

const AppImage = props => (
  <img {..._.omit(props, ['footerImage'])} src={props.footerImage} alt="" />
);
export default AppImage;
